import { actionTypes } from '../actions/types';

// import { Samtykke as Consent } from '../generated-types';

type AppActions = import('../actions/types').AppActions;

// TODO: Extend Consent from generated-types!
interface Consent {
    infoTekst: string;
    popupTekst: string;
    samtykkeId: {
        value: string;
    };
    svarNeiTekst: string;
    tekster: string[];
    tittel: string;
}

export interface ConsentData extends Consent {
    samtykkeId: any;
    svar: string;
}
export interface ConsentReducer {
    data: ConsentData[];
}

export const initialState: ConsentReducer = {
    data: [],
};

export const consentReducer = (state = initialState, action: AppActions = {} as AppActions): ConsentReducer => {
    switch (action.type) {
        case actionTypes.FETCH_CONSENT_FULFILLED: {
            return {
                ...state,
                data: action.payload.map((c: any) => {
                    if (state.data) {
                        state.data.forEach((storedConsent) => {
                            if (storedConsent.samtykkeId.value === c.samtykkeId.value) {
                                c.svar = storedConsent.svar;
                            }
                        });
                    }
                    return c;
                }),
            };
        }
        case actionTypes.FETCH_CONSENT_FAILED: {
            return {
                ...state,
                data: [],
            };
        }

        case actionTypes.UPDATE_CONSENT: {
            const { name, value } = action.payload;

            return {
                ...state,
                data: state.data.map((c) => {
                    const id = c.samtykkeId.value;

                    if (id === name) {
                        return {
                            ...c,
                            svar: value,
                        };
                    }

                    return c;
                }),
            };
        }

        default:
            return state;
    }
};
